import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
	root: {
		color: '#fff',
		background: '#f8cf74'
	}
}));

export default useStyles;
